module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzEiIGhlaWdodD0iMzEiIHZpZXdCb3g9IjAgMCAzMSAzMSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxjaXJjbGUgY3g9IjE1LjUiIGN5PSIxNS41IiByPSIxNSIgc3Ryb2tlPSIjOUQ4NDY2Ii8+DQo8cGF0aCBkPSJNOCA4TDIzIDIyLjk5OTYiIHN0cm9rZT0iIzlEODQ2NiIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4NCjxwYXRoIGQ9Ik0yMy4wMDAyIDhMOC4wMDA2MSAyMyIgc3Ryb2tlPSIjOUQ4NDY2IiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPg0KPC9zdmc+DQo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/closeDeposit.svg
// module id = s7JA
// module chunks = 0